import { LayoutComponent } from "./component";
import { useCustomer } from "../../contexts/app/provider";
import { ROOT_ROLE } from "../../constants/user";
import { useContext } from "react";
import { ApiContext } from "../../contexts/app/context";

export const LayoutContainer = () => {
  const { whoIAm, loading, selectedCustomerId } = useCustomer();
  const { actualRole } = useContext(ApiContext);

  // Use actual role (not effective role) for customer selection logic
  // ROOT users can select customers even in demo mode
  const role = actualRole || null;
  const customerId =
    role === ROOT_ROLE ? selectedCustomerId : whoIAm?.customerId || null;

  return <LayoutComponent customerId={customerId} loading={loading} />;
};
